import { BASE_URL } from '@~/constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'PARENT_PROFILE_INFO_GET',
  GET_SUCCESS: 'PARENT_PROFILE_INFO_SUCCESS',
  GET_FAILURE: 'PARENT_PROFILE_INFO_FAILURE',
  PATCH: 'PARENT_PROFILE_INFO_PATCH',
  PATCH_SUCCESS: 'PARENT_PROFILE_INFO_PATCH_SUCCESS',
  PATCH_FAILURE: 'PARENT_PROFILE_INFO_PATCH_FAILURE',
  INVALIDATE_ITEM: 'PARENT_PROFILE_INFO_INVALIDATE',
};

export const get = actions.get(
  parentServiceId => `${BASE_URL}/parents/${parentServiceId}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);

export const patch = actions.patch(parentUserId => `${BASE_URL}/user/${parentUserId}`, {
  PENDING: ACTIONS.PATCH,
  SUCCESS: ACTIONS.PATCH_SUCCESS,
  FAILURE: ACTIONS.PATCH_FAILURE,
});

export const invalidateItem = id => dispatch => {
  dispatch({
    type: ACTIONS.INVALIDATE_ITEM,
    payload: {
      id,
    },
  });
};
